<template>
    <div ref="eobj" id="edit-object">
        <!-- show info about this edit -->
        <h3>{{this.localData.DateRequested}}</h3>
        <h3>Changed "{{this.localData.OldValue == null || this.localData.OldValue == "" ? "None" : this.localData.OldValue}}" to "{{this.localData.NewValue}}"</h3>
        <h3>Comments: "{{this.localData.DataSourceComment == "" || this.localData.DataSourceComment == null ? "No Comments" : this.localData.DataSourceComment}}"</h3>
        <h3>{{this.localData.ChangedBy ? this.localData.ChangedBy : "Anonymous"}}</h3>
        <div style="margin-right:10px;">
            <i style="margin-right:10px" v-if="$parent.isManaged && this.localData.ReviewStatus==='P'" v-on:click="acceptEdit()" class="fa fa-check"></i>
            <i v-if="$parent.isManaged && this.localData.ReviewStatus==='P'" v-on:click="rejectEdit()" class="fa fa-times"></i>
            <i v-if="$parent.isManaged && this.localData.ReviewStatus!=='P'" v-on:click="undoStatusChange()" class="fas fa-undo"></i>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import axios from 'axios';
import constants from '../../constants.js';

export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            EditDate: "",
            localData: { ...this.data }
        }
    },
    mounted: function(){
        // Create a local copy of the prop
        this.localData = { ...this.data };
        this.changeStatus();
        this.localData.DateRequested = moment(this.localData.DateRequested).format('MMMM Do YYYY, h:mm:ss a');
    },
    methods: {
        acceptEdit() {
            this.$emit('official', {Type:'Accept', eID: this.data.EditID});
            this.localData.ReviewStatus = 'A';
            this.changeStatus();
        },
        rejectEdit() {
            this.$emit('official', {Type:'Reject', eID: this.data.EditID});
            this.localData.ReviewStatus = 'R';
            this.changeStatus();
        },
        //change edit status on acceptance / rejection
        changeStatus(){
                if(this.localData.ReviewStatus === 'A'){
                    this.$refs.eobj.style.backgroundColor = "#B7FFB3";
                }
                if(this.localData.ReviewStatus === 'R'){
                    this.$refs.eobj.style.backgroundColor = "#FFBEBE";
                }
        },
        undoStatusChange(){
            let url = constants.API_ENDPOINT + 'edit/undo/'
            axios
                .post(url,{ EditID: this.data.EditID }, {
                    headers: {
                        Authorization: this.$store.getters.authToken
                    }
                })
                .then(() => {
                    this.localData.ReviewStatus = 'P';
                    this.$refs.eobj.style.backgroundColor = "white";
                })
                .catch(() => {
                    alert("Edit could not be undone, you may have edits that were applied after this one")
                })
        }
    }
}
</script>

<style scoped>
#edit-object{
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    padding: 10px;
    background-clip: content-box;
    background-color: white;
}
h1,h2,h3{
    font-family: "Roboto Condensed";
    color: #4b4e52;
    width: 20%;
}
h3{
    font-size: 15px;
    margin: 0px;
}
#content-body{
    display: flex;
    flex-direction: column;
}
</style>